import { QNode, QStateObject, QStep, QThenFunction } from "./QFlow";

type LogicFunction = (state: QStateObject) => QStep;

/**
 * This node implements logic using a callback, which should return a QStep (to go to) or false (to do nothing)
 */
class LogicNode extends QNode {
    private logic: LogicFunction;
    constructor(logic: LogicFunction) {
        super();
        this.logic = logic;
    }

    go(state: QStateObject, then: QThenFunction) : void {
        var n = this.logic(state);

        //console.debug("Logic result", n);

        then(state, n);
    }

    isVisible() {
        return false;
    }
}

export default LogicNode;